import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Seperator from "components/Seperator";
import MonthPicker from "./MonthPicker";
import { useDispatch } from "react-redux";
import {
  selectedMonthOnReport,
  selectedWeekOnReview,
} from "redux/actions/appActions";
import WeekPicker from "pages/Timesheet/WeekPicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";

const ReportHeader = (props) => {
  const dispatch = useDispatch();
  const [month, setMonth] = props.dateHandles;
  const [startDate, setStartDate] = props.weekHandles;
  const { optionsAvailable } = props;
  const [view, setView] = props.viewHandles;
  const { t } = useTranslation();
  

  const monthChangeHandler = (date) => {
    console.log("ReportHeader > MonthPicker value changed===", date);
    setMonth(date);
    dispatch(selectedMonthOnReport(date));
  };

  const viewChangeHandler = (e, newValue) => {
    setView(newValue);
  };

  const weekChangeHandler = (date) => {
    setStartDate(date);
    dispatch(selectedWeekOnReview({ week: date }));
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item>
          <Autocomplete
            id="selection"
            disableClearable
            options={optionsAvailable}
            defaultValue={optionsAvailable[0]}
            getOptionLabel={(option) => option ?
               option === "Weekly" ?
               properCase(t("other.lblWeekly")) :
               option === "Monthly" ?
               properCase(t("other.lblMonthly")) :
               option :
               "NA"
            }
            style={{ width: 150 }}
            renderInput={(params) => (
              <TextField
                required={true}
                {...params}
                label={properCase(t("other.tlselectedView"))}
                variant="outlined"
                size="small"
              />
            )}
            onChange={viewChangeHandler}
          />
        </Grid>

        <Grid item>
          {
            //for monthly view display month picker otherwise display week picker component
            view === "Monthly" ? (
              <MonthPicker
                startMonth={month}
                monthChangeHandler={monthChangeHandler}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={properCase(t("other.tlselectedMonth"))}
                    size="small"
                    variant="outlined"
                  />
                )}
              />
            ) : (
              <WeekPicker
                size="small"
                variant="outlined"
                weekChangeHandler={weekChangeHandler}
                startDate={startDate}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={properCase(t("pgHome.lblReportWeek"))}
                    size="small"
                    variant="outlined"
                  />
                )}
                minDate={moment(new Date())
                  .subtract(3, "months")
                  .startOf("month")}
                maxDate={moment(new Date()).add(2, "weeks")}
              />
            )
          }
        </Grid>
        <Seperator />
      </Grid>
    </>
  );
};

ReportHeader.propTypes = {
  dateHandles: PropTypes.array.isRequired,
  weekHandles: PropTypes.array.isRequired,
  optionsAvailable: PropTypes.array.isRequired,
  viewHandles: PropTypes.array.isRequired,
};

export default ReportHeader;
